module.exports = __webpack_public_path__ + "img/entmod-1st-Module-for-New-EA.faa0d8c3.jpeg";